module.exports = __webpack_public_path__ + "static/media/GR.b055ef0c.png";